module.exports = __webpack_public_path__ + "static/img/Yusen.fa670d4c.png";